(() => {
  const form = document.querySelector("#feed-advisor-onepage-form");
  const results = document.querySelector("#feed-advisor-onepage-results");
  const dogNameEl = results?.querySelector("[data-dog-name]");
  const dogSummaryEl = results?.querySelector("[data-dog-summary]");
  const dogCaloriesEl = results?.querySelector("[data-dog-calories]");
  const packagesEl = results?.querySelector("[data-packages]");
  const menuSourceWrap = results?.querySelector("[data-menu-source]");
  const menuSourceInputs = menuSourceWrap
    ? Array.from(menuSourceWrap.querySelectorAll("input[name='menu_collection']"))
    : [];
  const recommendedWrap = results?.querySelector("[data-recommended-products]");
  const recommendedList = results?.querySelector("[data-recommended-list]");
  const puppyWrap = results?.querySelector("[data-puppy-products]");
  const puppyList = results?.querySelector("[data-puppy-list]");
  const extraWrap = results?.querySelector("[data-extra-products]");
  const extraList = results?.querySelector("[data-extra-list]");
  const complaintsWrap = form?.querySelector("[data-complaints]");
  const allergiesWrap = form?.querySelector("[data-allergies]");

  if (!form || !results || !packagesEl) return;

  const data = window.feedAdvisorOnePageData || {};
  const menuCollections =
    data.menuCollections && typeof data.menuCollections === "object"
      ? data.menuCollections
      : {
          frozen: {
            key: "frozen",
            label: "Gefrorene Menüs",
            menus: Array.isArray(data.frischeMenus) ? data.frischeMenus : [],
            availableVariants: Array.isArray(data.availableFrischeVariants)
              ? data.availableFrischeVariants
              : [],
            packageBoxes: data.packageBoxes || {},
          },
        };
  const menuCollectionKeys = Object.keys(menuCollections);
  const defaultMenuCollectionKey = menuCollections[data.defaultMenuCollection]
    ? data.defaultMenuCollection
    : menuCollectionKeys[0];
  let selectedMenuCollectionKey = defaultMenuCollectionKey;
  const normalizeTitle = (value) =>
    String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  const proteinKeyMap = {
    chicken: "huhn",
    beef: "rind",
    salmon: "lachs",
    turkey: "pute",
    duck: "ente",
    horse: "pferd",
    lamb: "lamm",
    insect: "insekt",
  };
  const getMenuCollectionData = (collectionKey) => {
    const collection = menuCollections[collectionKey] || {};
    const baseProductsList =
      collectionKey === "jars" && typeof productsJarList !== "undefined"
        ? productsJarList
        : typeof productsList !== "undefined"
          ? productsList
          : {};
    const frischeMenus = Array.isArray(collection.menus) ? collection.menus : [];
    const availableVariants = Array.isArray(collection.availableVariants)
      ? collection.availableVariants
      : [];
    const availableVariantIds = availableVariants.length
      ? new Set(
          availableVariants
            .map((item) => String(item?.id || ""))
            .filter(Boolean),
        )
      : null;
    const availableVariantByTitle = availableVariants.reduce((acc, item) => {
      const key = normalizeTitle(item?.title);
      if (key && item?.id) acc[key] = item.id;
      return acc;
    }, {});
    const availableVariantByHandle = availableVariants.reduce((acc, item) => {
      const key = String(item?.handle || "").trim();
      if (key && item?.id) acc[key] = item.id;
      return acc;
    }, {});
    const frischeMenusByHandle = frischeMenus.reduce((acc, item) => {
      const key = String(item?.handle || "").trim();
      if (key) acc[key] = item;
      return acc;
    }, {});
    const availableProducts = Object.keys(availableVariantByHandle)
      .map((handle) => {
        const menu = frischeMenusByHandle[handle];
        if (!menu) return null;
        return {
          id: availableVariantByHandle[handle],
          name: menu.title,
          img: menu.image,
          handle: menu.handle,
        };
      })
      .filter(Boolean);
    const productByVariantId = availableProducts.reduce((acc, item) => {
      if (item?.id) acc[String(item.id)] = item;
      return acc;
    }, {});
    const findVariantIdForName = (name) => {
      const normalized = normalizeTitle(name);
      if (!normalized) return null;
      if (availableVariantByTitle[normalized]) {
        return availableVariantByTitle[normalized];
      }
      const match = Object.entries(availableVariantByTitle).find(
        ([key]) => key.includes(normalized) || normalized.includes(key),
      );
      return match ? match[1] : null;
    };
    const findVariantIdForKey = (key) => {
      const token = normalizeTitle(proteinKeyMap[key] || key);
      if (!token) return null;
      const match = availableProducts.find((item) =>
        normalizeTitle(item?.name).includes(token),
      );
      return match ? match.id : null;
    };
    const resolvedProductsList =
      !Object.keys(baseProductsList).length
        ? {}
        : Object.fromEntries(
            Object.entries(baseProductsList).map(([key, value]) => {
              const matchId =
                findVariantIdForName(value?.name) || findVariantIdForKey(key);
              if (matchId) {
                const matched = productByVariantId[String(matchId)];
                return [
                  key,
                  { ...value, id: matchId, img: matched?.img || value.img },
                ];
              }
              return [key, value];
            }),
          );
    return {
      availableVariantIds,
      availableProducts,
      frischeMenus,
      packageBoxes: collection.packageBoxes || data.packageBoxes || {},
      packageUnitGrams: collection.packageUnitGrams,
      label: collection.label || "",
      resolvedProductsList,
    };
  };
  const getSelectedMenuCollectionData = () =>
    getMenuCollectionData(selectedMenuCollectionKey);
  const getPackageUnitGrams = (collectionData) => {
    const value = Number(collectionData?.packageUnitGrams);
    return value > 0 ? value : 500;
  };
  const getPackageTotalGrams = (boxData, fallbackCount, packageUnitGrams) => {
    const totalGrams = Number(boxData?.totalGrams);
    if (totalGrams > 0) return totalGrams;
    const packageCount = Number(boxData?.packageCount);
    if (packageCount > 0) return packageCount * packageUnitGrams;
    return fallbackCount * packageUnitGrams;
  };
  const getPackageCount = (boxData, fallbackCount) => {
    const packageCount = Number(boxData?.packageCount);
    return packageCount > 0 ? packageCount : fallbackCount;
  };
  const formatProductNameWithUnit = (name, packageUnitGrams) =>
    String(name || "").replace(/\b\d+\s*g\b/gi, `${packageUnitGrams}g`);
  const supplementsByComplaint = data.supplementsByComplaint || {};
  const breedSpecificSupplements = data.breedSpecificSupplements || {};
  const puppyGrowthProduct = data.puppyGrowthProduct || {};
  const extraProducts = Array.isArray(data.extraProducts)
    ? data.extraProducts
    : [];
  const promo = data.promo || {};
  const breedInput = form.querySelector("#fa-breed");
  const breedPanel = form.querySelector("#fa-breed-options");
  const breedEmpty = breedPanel?.querySelector("[data-empty]");
  const typeaheadWrap = form.querySelector("[data-breed-typeahead]");
  let breedOptions = [];
  let activeIndex = -1;

  const setFieldError = (field, message) => {
    const errorEl = form.querySelector(`[data-error-for="${field.name}"]`);
    if (!errorEl) return;
    if (message) {
      field.classList.add("is-error");
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      field.classList.remove("is-error");
      errorEl.hidden = true;
    }
  };

  const validateField = (field) => {
    const value = field.value.trim();
    let error = "";

    if (field.name === "name" && !value) {
      error = "Bitte gebe den Namen deines Hundes ein.";
    } else if (field.name === "email_address") {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !regex.test(value)) {
        error = "Bitte gebe eine gültige E-Mail-Adresse ein.";
      }
    } else if (field.name === "weight") {
      const weightValue = Number(value);
      if (!weightValue || weightValue < 1 || weightValue > 100) {
        error = "Bitte gib einen Wert zwischen 1 und 100 kg ein.";
      }
    } else if (field.name === "breed" && !value) {
      error = "Bitte wähle eine Rasse aus.";
    } else if (field.name === "age" && !value) {
      error = "Bitte wähle das Alter aus.";
    } else if (field.name === "activity" && !value) {
      error = "Bitte wähle das Aktivitätslevel aus.";
    } else if (field.name === "castrated" && !value) {
      error = "Bitte wähle eine Option aus.";
    } else if (field.name === "body" && !value) {
      error = "Bitte wähle die Körperform aus.";
    } else if (field.name === "snacks" && !value) {
      error = "Bitte wähle den Snack-Anteil aus.";
    }

    setFieldError(field, error);
    return !error;
  };

  const validateForm = () => {
    const fields = Array.from(form.querySelectorAll("input, select")).filter(
      (field) => field.name && field.type !== "checkbox",
    );
    return fields.every((field) => validateField(field));
  };

  form.addEventListener("focusout", (event) => {
    const field = event.target;
    if (!field || !field.name || field.type === "checkbox") return;
    validateField(field);
  });

  form.addEventListener("input", (event) => {
    const field = event.target;
    if (!field || !field.name || field.type === "checkbox") return;
    validateField(field);
  });

  form.addEventListener("change", (event) => {
    const field = event.target;
    if (!field || !field.name || field.type === "checkbox") return;
    validateField(field);
  });

  const renderOptions = (items) => {
    if (!breedPanel) return;
    breedPanel.innerHTML = "";
    if (items.length === 0) {
      const empty = document.createElement("div");
      empty.className = "feed-advisor-onepage__typeahead-empty";
      empty.textContent = "Keine Treffer";
      breedPanel.appendChild(empty);
      return;
    }
    items.forEach((breed, index) => {
      const option = document.createElement("button");
      option.type = "button";
      option.className = "feed-advisor-onepage__typeahead-option";
      option.setAttribute("role", "option");
      option.dataset.index = String(index);
      option.textContent = breed;
      breedPanel.appendChild(option);
    });
  };

  const openPanel = () => {
    if (!breedPanel || !breedInput) return;
    breedPanel.hidden = false;
    breedInput.setAttribute("aria-expanded", "true");
  };

  const closePanel = () => {
    if (!breedPanel || !breedInput) return;
    breedPanel.hidden = true;
    breedInput.setAttribute("aria-expanded", "false");
    activeIndex = -1;
  };

  const highlightOption = (index) => {
    if (!breedPanel) return;
    const options = breedPanel.querySelectorAll(
      ".feed-advisor-onepage__typeahead-option",
    );
    options.forEach((option) => option.classList.remove("is-active"));
    if (options[index]) {
      options[index].classList.add("is-active");
      options[index].scrollIntoView({ block: "nearest" });
    }
  };

  const filterBreeds = (query) => {
    const normalized = query.trim().toLowerCase();
    if (!normalized) {
      return breedOptions.slice();
    }
    return breedOptions.filter((breed) =>
      breed.toLowerCase().includes(normalized),
    );
  };

  const updatePanel = () => {
    if (!breedInput) return;
    const items = filterBreeds(breedInput.value);
    renderOptions(items);
    openPanel();
  };

  const setBreed = (value) => {
    if (!breedInput) return;
    breedInput.value = value;
    closePanel();
    validateField(breedInput);
  };

  const initTypeahead = () => {
    if (!breedInput || !breedPanel || !typeaheadWrap) return;
    breedInput.addEventListener("input", () => {
      activeIndex = -1;
      updatePanel();
    });

    breedInput.addEventListener("focus", () => {
      updatePanel();
    });

    breedInput.addEventListener("blur", () => {
      window.setTimeout(() => {
        closePanel();
        validateField(breedInput);
      }, 150);
    });

    breedInput.addEventListener("keydown", (event) => {
      const options = breedPanel.querySelectorAll(
        ".feed-advisor-onepage__typeahead-option",
      );
      if (!options.length) return;
      if (event.key === "ArrowDown") {
        event.preventDefault();
        activeIndex = (activeIndex + 1) % options.length;
        highlightOption(activeIndex);
      } else if (event.key === "ArrowUp") {
        event.preventDefault();
        activeIndex = (activeIndex - 1 + options.length) % options.length;
        highlightOption(activeIndex);
      } else if (event.key === "Enter") {
        if (activeIndex >= 0 && options[activeIndex]) {
          event.preventDefault();
          setBreed(options[activeIndex].textContent);
        }
      } else if (event.key === "Escape") {
        closePanel();
      }
    });

    breedPanel.addEventListener("click", (event) => {
      const target = event.target.closest(
        ".feed-advisor-onepage__typeahead-option",
      );
      if (!target) return;
      setBreed(target.textContent);
    });

    document.addEventListener("click", (event) => {
      if (!typeaheadWrap.contains(event.target)) {
        closePanel();
      }
    });
  };

  const loadBreeds = () => {
    if (Array.isArray(window.dogBreeds)) {
      breedOptions = window.dogBreeds.slice();
      if (breedEmpty) breedEmpty.textContent = "Bitte tippen, um zu suchen";
      initTypeahead();
      return;
    }
    if (typeof dogBreeds !== "undefined" && Array.isArray(dogBreeds)) {
      breedOptions = dogBreeds.slice();
      if (breedEmpty) breedEmpty.textContent = "Bitte tippen, um zu suchen";
      initTypeahead();
      return;
    }
    let timeoutId = null;
    const intervalId = window.setInterval(() => {
      if (Array.isArray(window.dogBreeds)) {
        breedOptions = window.dogBreeds.slice();
        window.clearInterval(intervalId);
        if (timeoutId) window.clearTimeout(timeoutId);
        if (breedEmpty) breedEmpty.textContent = "Bitte tippen, um zu suchen";
        initTypeahead();
      } else if (typeof dogBreeds !== "undefined" && Array.isArray(dogBreeds)) {
        breedOptions = dogBreeds.slice();
        window.clearInterval(intervalId);
        if (timeoutId) window.clearTimeout(timeoutId);
        if (breedEmpty) breedEmpty.textContent = "Bitte tippen, um zu suchen";
        initTypeahead();
      }
    }, 200);
    timeoutId = window.setTimeout(() => {
      window.clearInterval(intervalId);
      if (breedEmpty)
        breedEmpty.textContent = "Liste konnte nicht geladen werden";
    }, 5000);
  };

  loadBreeds();

  const selectComplaint = (target) => {
    if (!complaintsWrap) return;
    if (target.value === "none" && target.checked) {
      complaintsWrap
        .querySelectorAll("input[name='complaints']")
        .forEach((box) => {
          if (box.value !== "none") box.checked = false;
        });
    }
    if (target.value !== "none" && target.checked) {
      const noneBox = complaintsWrap.querySelector("input[value='none']");
      if (noneBox) noneBox.checked = false;
    }
  };

  complaintsWrap?.addEventListener("change", (event) => {
    if (event.target?.matches("input[name='complaints']")) {
      selectComplaint(event.target);
      const selectedComplaints = Array.from(
        complaintsWrap.querySelectorAll("input[name='complaints']:checked"),
      ).map((input) => input.value);
      console.log("[Feed Advisor] Selected complaints", {
        complaints: selectedComplaints,
      });
    }
  });

  const setGroupError = (group, message, key) => {
    const errorEl = form.querySelector(`[data-error-for="${key}"]`);
    if (!errorEl || !group) return;
    if (message) {
      group.classList.add("is-error");
      errorEl.textContent = message;
      errorEl.hidden = false;
    } else {
      group.classList.remove("is-error");
      errorEl.hidden = true;
    }
  };

  const validateAllergies = () => {
    if (!allergiesWrap) return true;
    const allBoxes = Array.from(
      allergiesWrap.querySelectorAll("input[type='checkbox']"),
    );
    const checked = allBoxes.filter((box) => box.checked);

    // Must select at least one option
    if (checked.length === 0) {
      setGroupError(
        allergiesWrap,
        "Bitte wähle mindestens eine Option aus.",
        "allergies",
      );
      return false;
    }

    // If "no_allergy" is checked, it's valid
    const noAllergyChecked = checked.some((box) => box.value === "no_allergy");
    if (noAllergyChecked) {
      setGroupError(allergiesWrap, "", "allergies");
      return true;
    }

    // Count how many allergy options are NOT checked (excluding no_allergy)
    const allergyBoxes = allBoxes.filter((box) => box.value !== "no_allergy");
    const uncheckedCount = allergyBoxes.filter((box) => !box.checked).length;

    // Need at least 2 unchecked to have enough product variety
    if (uncheckedCount < 2) {
      setGroupError(
        allergiesWrap,
        "Bitte lasse mindestens 2 Kategorien frei, damit wir genügend Produktauswahl haben.",
        "allergies",
      );
      return false;
    }

    setGroupError(allergiesWrap, "", "allergies");
    return true;
  };

  const selectAllergy = (target) => {
    if (!allergiesWrap) return;
    if (target.value === "no_allergy" && target.checked) {
      allergiesWrap
        .querySelectorAll("input[type='checkbox']")
        .forEach((box) => {
          if (box.value !== "no_allergy") box.checked = false;
        });
    }
    if (target.value !== "no_allergy" && target.checked) {
      const noneBox = allergiesWrap.querySelector("input[value='no_allergy']");
      if (noneBox) noneBox.checked = false;
    }
    validateAllergies();
  };

  allergiesWrap?.addEventListener("change", (event) => {
    if (event.target?.matches("input[type='checkbox']")) {
      selectAllergy(event.target);
    }
  });

  const getRecommendedSize = (weight) => {
    if (weight <= 10) return "S";
    if (weight <= 25) return "M";
    return "L";
  };

  const getAverageCaloriesPerGram = (
    resolvedProductsList,
    availableVariantIds,
    packageUnitGrams,
  ) => {
    if (!resolvedProductsList || !Object.keys(resolvedProductsList).length) {
      return null;
    }
    const items = Object.values(resolvedProductsList).filter((item) =>
      availableVariantIds ? availableVariantIds.has(String(item.id)) : true,
    );
    if (!items.length) return null;
    const caloriesTotal = items.reduce(
      (sum, item) => sum + Number(item.calories || 0),
      0,
    );
    const avgCaloriesPerPack = caloriesTotal / items.length;
    return avgCaloriesPerPack > 0 ? avgCaloriesPerPack / packageUnitGrams : null;
  };

  const getAvailableProductsMap = (frischeMenus) => {
    if (!Array.isArray(frischeMenus)) return {};
    return frischeMenus.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
  };

  const filterProductsByAllergies = (
    allergyKeys,
    resolvedProductsList,
    availableVariantIds,
  ) => {
    if (!resolvedProductsList || !Object.keys(resolvedProductsList).length) {
      return {};
    }
    const blocked = new Set(allergyKeys);
    const filtered = {};
    Object.entries(resolvedProductsList).forEach(([key, value]) => {
      if (
        !blocked.has(key) &&
        (!availableVariantIds || availableVariantIds.has(String(value.id)))
      ) {
        filtered[key] = value;
      }
    });
    return filtered;
  };

  const createPackage = (weight, products, dogCalories, packageUnitGrams = 500) => {
    const sorted = Object.fromEntries(
      Object.entries(products).sort((x, y) => x[1].priority - y[1].priority),
    );
    const factor = weight / 2000;
    const formData = [];
    const productData = [];
    const ids = [];
    const names = [];
    const images = [];
    const calories = [];
    let totalCalories = 0;

    for (const [, value] of Object.entries(sorted)) {
      ids.push(value.id);
      names.push(value.name);
      images.push(value.img);
      calories.push(value.calories);
    }

    if (ids.length > factor) {
      for (let i = 0; i < Math.ceil(factor); i++) {
        if (i + 1 <= Math.floor(factor)) {
          formData[i] = { id: ids[i], quantity: 4 };
          productData[i] = { ...formData[i], name: names[i], img: images[i] };
          totalCalories += calories[i] * 4;
        } else {
          formData[i] = { id: ids[i], quantity: 2 };
          productData[i] = { ...formData[i], name: names[i], img: images[i] };
          totalCalories += calories[i] * 2;
        }
      }
    } else {
      const problemFactor = weight / ids.length / packageUnitGrams;
      const leftProblemFactor = Math.ceil(problemFactor) - problemFactor;

      for (let i = 0; i < ids.length; i++) {
        if (leftProblemFactor > 0) {
          if (i === ids.length - 1) {
            const calc =
              (weight - Math.ceil(problemFactor) * i * packageUnitGrams) /
              packageUnitGrams;
            if (calc > 0) {
              formData[i] = { id: ids[i], quantity: calc };
              productData[i] = {
                ...formData[i],
                name: names[i],
                img: images[i],
              };
              totalCalories += calories[i] * calc;
            }
          } else {
            formData[i] = {
              id: ids[i],
              quantity: Math.ceil(problemFactor),
            };
            totalCalories += calories[i] * Math.ceil(problemFactor);
            productData[i] = { ...formData[i], name: names[i], img: images[i] };
          }
        } else {
          formData[i] = {
            id: ids[i],
            quantity: problemFactor,
          };
          productData[i] = { ...formData[i], name: names[i], img: images[i] };
          totalCalories += calories[i] * problemFactor;
        }
      }
    }

    const lastInDays = Math.round(totalCalories / dogCalories);
    const caloriesPerDay = Math.round(weight / lastInDays);

    return { formData, lastInDays, productData, caloriesPerDay };
  };

  const createTwoProductPackage = (
    weight,
    products,
    dogCalories,
    packageUnitGrams = 500,
    packageCount = null,
  ) => {
    const sorted = Object.fromEntries(
      Object.entries(products).sort((x, y) => x[1].priority - y[1].priority),
    );
    const entries = Object.values(sorted);
    if (!entries.length) {
      return {
        formData: [],
        lastInDays: 0,
        productData: [],
        caloriesPerDay: 0,
      };
    }
    const first = entries[0];
    const second = entries[1] || entries[0];
    const packsTotal =
      Number(packageCount) > 0
        ? Number(packageCount)
        : Math.round(weight / packageUnitGrams);
    const quantityPerProduct = Math.max(1, Math.round(packsTotal / 2));
    const productData = [
      {
        id: first.id,
        quantity: quantityPerProduct,
        name: first.name,
        img: first.img,
      },
      {
        id: second.id,
        quantity: quantityPerProduct,
        name: second.name,
        img: second.img,
      },
    ];
    let formData = [
      { id: first.id, quantity: quantityPerProduct },
      { id: second.id, quantity: quantityPerProduct },
    ];
    if (String(first.id) === String(second.id)) {
      formData = [{ id: first.id, quantity: quantityPerProduct * 2 }];
    }
    const totalCalories =
      first.calories * quantityPerProduct +
      second.calories * quantityPerProduct;
    const lastInDays = Math.round(totalCalories / dogCalories);
    const caloriesPerDay = Math.round(weight / lastInDays);
    return { formData, lastInDays, productData, caloriesPerDay };
  };

  const getSupplementSelection = (complaints, breed) => {
    const supplementItems = [];
    const normalizedBreed = breed.trim();

    complaints.forEach((complaint) => {
      const item = supplementsByComplaint[complaint];
      if (item) supplementItems.push(item);
    });

    if (normalizedBreed && breedSpecificSupplements[normalizedBreed]) {
      supplementItems.push(breedSpecificSupplements[normalizedBreed]);
    }

    return supplementItems;
  };

  const formatPrice = (cents) => {
    if (!cents) return "";
    const euros = (cents / 100).toFixed(2).replace(".", ",");
    return `€${euros}`;
  };

  const buildRecommendedProductCard = (product) => {
    const card = document.createElement("div");
    card.className = "feed-advisor-recommended-product";

    const imageWrap = document.createElement("div");
    imageWrap.className = "feed-advisor-recommended-product__image";
    const img = document.createElement("img");
    img.src = product.image;
    img.alt = product.title;
    imageWrap.appendChild(img);
    card.appendChild(imageWrap);

    const content = document.createElement("div");
    content.className = "feed-advisor-recommended-product__content";

    const title = document.createElement("h4");
    title.className = "feed-advisor-recommended-product__title";
    title.textContent = product.title;
    content.appendChild(title);

    const priceWrap = document.createElement("div");
    priceWrap.className = "feed-advisor-recommended-product__price-wrap";

    if (product.compareAtPrice && product.compareAtPrice > product.price) {
      const comparePrice = document.createElement("span");
      comparePrice.className =
        "feed-advisor-recommended-product__compare-price";
      comparePrice.textContent = formatPrice(product.compareAtPrice);
      priceWrap.appendChild(comparePrice);
    }

    const price = document.createElement("span");
    price.className = "feed-advisor-recommended-product__price";
    price.textContent = formatPrice(product.price);
    priceWrap.appendChild(price);
    content.appendChild(priceWrap);

    const button = document.createElement("span");
    button.className =
      "add-to-cart sf__btn sf__btn-secondary feed-advisor-recommended-product__btn";
    button.textContent = product.available ? "in den Warenkorb" : "Coming Soon";
    if (product.available) {
      button.onclick = function (e) {
        e.preventDefault();
        const formData = {
          items: [{ id: product.variantId, quantity: 1 }],
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function () {
            Shopify.onItemAdded();
          })
          .catch(function (error) {
            alert("Error:", error);
          });
      };
    } else {
      button.setAttribute("aria-disabled", "true");
    }
    content.appendChild(button);

    card.appendChild(content);
    return card;
  };

  const fetchProductByHandle = async (handle, source = "product") => {
    try {
      const url = window.Shopify.routes.root + `products/${handle}.js`;
      console.log(`[Feed Advisor] Fetching ${source}`, {
        handle,
        url,
      });
      const response = await fetch(url);
      console.log(`[Feed Advisor] ${source} response`, {
        handle,
        ok: response.ok,
        status: response.status,
        statusText: response.statusText,
      });
      if (!response.ok) {
        console.error(`[Feed Advisor] ${source} request failed`, {
          handle,
          status: response.status,
          statusText: response.statusText,
        });
        return null;
      }
      const product = await response.json();
      console.log(`[Feed Advisor] ${source} payload`, { handle, product });
      const variant =
        product.variants?.find((item) => item.available) || product.variants?.[0];
      if (!variant) {
        console.warn(`[Feed Advisor] ${source} has no variants`, { handle });
        return null;
      }
      return {
        variantId: variant.id,
        title: product.title,
        url: product.url || `/products/${handle}`,
        image: product.featured_image,
        price: variant.price,
        compareAtPrice: variant.compare_at_price,
        available: Boolean(variant.available),
      };
    } catch (error) {
      console.error(`[Feed Advisor] Error fetching ${source}`, {
        handle,
        error,
      });
      return null;
    }
  };

  const renderRecommendedProducts = async (complaints) => {
    if (!recommendedWrap || !recommendedList) return;
    console.log("[Feed Advisor] renderRecommendedProducts called", {
      complaints,
      supplementsByComplaint,
    });

    const validComplaints = complaints.filter(Boolean);
    console.log("[Feed Advisor] Valid complaints", { validComplaints });
    if (!validComplaints.length) {
      console.log("[Feed Advisor] No valid complaints, hiding recommendations");
      recommendedWrap.hidden = true;
      return;
    }

    const supplementHandles = [];
    validComplaints.forEach((complaint) => {
      const supplement = supplementsByComplaint[complaint];
      console.log("[Feed Advisor] Complaint supplement mapping", {
        complaint,
        supplement,
      });
      if (supplement && supplement.handle) {
        supplementHandles.push({ complaint, handle: supplement.handle });
      }
    });

    if (!supplementHandles.length) {
      console.warn(
        "[Feed Advisor] No supplement handles found for complaints",
        { validComplaints, supplementsByComplaint },
      );
      recommendedWrap.hidden = true;
      return;
    }

    // Show loading state
    recommendedList.innerHTML = "<p>Laden...</p>";
    recommendedWrap.hidden = false;

    // Fetch all product data
    const products = [];
    for (const item of supplementHandles) {
      const productData = await fetchProductByHandle(
        item.handle,
        "supplement product",
      );
      console.log("[Feed Advisor] Supplement fetch result", {
        complaint: item.complaint,
        handle: item.handle,
        productData,
      });
      if (productData) {
        products.push({ ...productData, complaint: item.complaint });
      } else {
        console.warn("[Feed Advisor] Supplement missing", {
          complaint: item.complaint,
          handle: item.handle,
          productData,
        });
      }
    }

    if (!products.length) {
      console.warn("[Feed Advisor] No supplement products could be rendered", {
        supplementHandles,
      });
      recommendedWrap.hidden = true;
      return;
    }

    recommendedList.innerHTML = "";

    products.forEach((product) => {
      recommendedList.appendChild(buildRecommendedProductCard(product));
    });

    recommendedWrap.hidden = false;
  };

  const renderPuppyProduct = async (submission) => {
    if (!puppyWrap || !puppyList) return;
    if (!submission.isPuppy || !puppyGrowthProduct.handle) {
      puppyWrap.hidden = true;
      puppyList.innerHTML = "";
      return;
    }

    puppyList.innerHTML = "<p>Laden...</p>";
    puppyWrap.hidden = false;

    const product = await fetchProductByHandle(
      puppyGrowthProduct.handle,
      "puppy product",
    );
    console.log("[Feed Advisor] Puppy product fetch result", {
      handle: puppyGrowthProduct.handle,
      product,
    });

    if (!product) {
      puppyWrap.hidden = true;
      puppyList.innerHTML = "";
      return;
    }

    puppyList.innerHTML = "";
    puppyList.appendChild(buildRecommendedProductCard(product));
    puppyWrap.hidden = false;
  };

  let extrasRendered = false;
  const renderExtraProducts = async () => {
    if (!extraWrap || !extraList || extrasRendered) return;
    const handles = extraProducts
      .map((item) => item?.handle)
      .filter(Boolean);
    if (!handles.length) {
      extraWrap.hidden = true;
      return;
    }

    extrasRendered = true;
    extraList.innerHTML = "<p>Laden...</p>";
    extraWrap.hidden = false;

    const products = [];
    for (const handle of handles) {
      const product = await fetchProductByHandle(handle, "extra product");
      if (product) products.push(product);
    }

    if (!products.length) {
      extrasRendered = false;
      extraWrap.hidden = true;
      extraList.innerHTML = "";
      return;
    }

    extraList.innerHTML = "";
    products.forEach((product) => {
      extraList.appendChild(buildRecommendedProductCard(product));
    });
    extraWrap.hidden = false;
  };

  const addToCart = (items) => {
    if (!Array.isArray(items) || items.length === 0) {
      console.error("addToCart: No items provided", items);
      return;
    }
    const formData = {
      items: items.map((item) => ({
        id: item.id,
        quantity: Math.max(1, Math.round(item.quantity)),
      })),
    };
    console.log("addToCart: Sending to cart", formData);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        console.log("addToCart: Response status", response.status);
        return response.json();
      })
      .then((data) => {
        console.log("addToCart: Response data", data);
        Shopify.onItemAdded();
      })
      .catch((error) => {
        console.error("addToCart: Error", error);
        alert("Error:", error);
      });
  };

  const closeAllVarietyPanels = () => {
    document
      .querySelectorAll(".feed-advisor-product__variety-panel")
      .forEach((panelEl) => {
        panelEl.hidden = true;
      });
    document
      .querySelectorAll(".feed-advisor-product__variety-trigger")
      .forEach((triggerEl) => {
        triggerEl.setAttribute("aria-expanded", "false");
      });
  };

  document.addEventListener("click", (event) => {
    if (!event.target.closest(".feed-advisor-product__variety")) {
      closeAllVarietyPanels();
    }
  });

  const renderPackage = (
    size,
    packageData,
    supplements,
    recommendedSize,
    urlMap,
    dogName,
    availableProducts,
    packageBoxes,
    packageUnitGrams,
  ) => {
    const card = document.createElement("div");
    card.className = "feed-advisor-product";
    if (size === recommendedSize) {
      card.classList.add("is-recommended");
    }
    const buildCartItems = () => {
      console.log(
        "buildCartItems: packageData.productData",
        packageData.productData,
      );
      const map = new Map();
      packageData.productData.forEach((item) => {
        console.log("buildCartItems: processing item", item);
        if (!item || typeof item.id === "undefined") {
          console.log("buildCartItems: skipping invalid item");
          return;
        }
        const key = String(item.id);
        const quantity = Number(item.quantity) || 0;
        if (quantity <= 0) {
          console.log("buildCartItems: skipping zero quantity");
          return;
        }
        map.set(key, (map.get(key) || 0) + quantity);
      });
      const result = Array.from(map.entries()).map(([id, quantity]) => ({
        id: Number(id),
        quantity,
      }));
      console.log("buildCartItems: result", result);
      return result;
    };

    const boxData = packageBoxes[size] || {};
    if (boxData.image) {
      const boxImage = document.createElement("img");
      boxImage.src = boxData.image;
      boxImage.alt = boxData.title || `Versandbox ${size}`;
      boxImage.className = "feed-advisor-product__box";
      card.appendChild(boxImage);
    }

    const packageTitle = document.createElement("h3");
    packageTitle.textContent = boxData.title || `Versandbox ${size}`;
    card.appendChild(packageTitle);

    if (boxData.subtitle) {
      const subtitle = document.createElement("p");
      subtitle.className = "feed-advisor-product__subtitle";
      subtitle.textContent = boxData.subtitle;
      card.appendChild(subtitle);
    }

    if (boxData.description) {
      const description = document.createElement("p");
      description.textContent = boxData.description;
      card.appendChild(description);
    }

    const list = document.createElement("ul");
    const productOptions = availableProducts.length
      ? availableProducts
      : Array.isArray(availableProducts)
        ? availableProducts
        : Object.values(availableProducts || {});
    const hasVarietyOptions = productOptions.length > 1;
    const normalizeName = (value) =>
      String(value || "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    const optionByName = productOptions.reduce((acc, option) => {
      const key = normalizeName(option.name);
      if (key) acc[key] = option;
      return acc;
    }, {});
    const rebuildFormData = () => {
      const map = new Map();
      packageData.productData.forEach((item) => {
        const key = String(item.id);
        const current = map.get(key) || 0;
        map.set(key, current + Number(item.quantity || 0));
      });
      packageData.formData = Array.from(map.entries()).map(
        ([id, quantity]) => ({
          id: Number(id),
          quantity,
        }),
      );
    };
    const ensureAvailableIds = () => {
      if (!productOptions.length) return;
      const used = new Set();
      packageData.productData.forEach((menu) => {
        const normalized = normalizeName(menu.name);
        const matched =
          optionByName[normalized] ||
          productOptions.find((option) =>
            normalizeName(option.name).includes(normalized),
          );
        if (matched) {
          menu.id = matched.id;
          menu.name = matched.name;
          menu.img = matched.img;
          used.add(String(matched.id));
          return;
        }
        const fallback =
          productOptions.find((option) => !used.has(String(option.id))) ||
          productOptions[0];
        if (fallback) {
          menu.id = fallback.id;
          menu.name = fallback.name;
          menu.img = fallback.img;
          used.add(String(fallback.id));
        }
      });
      rebuildFormData();
    };

    const dropdowns = [];
    const rebuildVarietyOptions = () => {
      if (!hasVarietyOptions) return;
      const selectedIds = packageData.productData.map((item) =>
        String(item.id),
      );
      dropdowns.forEach((dropdown) => {
        dropdown.renderPanel(selectedIds);
      });
    };

    ensureAvailableIds();

    packageData.productData.forEach((menu, index) => {
      const item = document.createElement("li");
      item.className = "feed-advisor-product__menu";
      const row = document.createElement("div");
      row.className = "feed-advisor-product__menu-row";
      const rowMeta = document.createElement("div");
      rowMeta.className = "feed-advisor-product__menu-meta";
      const imgWrap = document.createElement("div");
      imgWrap.className = "feed-advisor-product__image-wrap";
      const img = document.createElement("img");
      img.src = menu.img;
      img.alt = formatProductNameWithUnit(menu.name, packageUnitGrams);
      imgWrap.appendChild(img);
      const qty = document.createElement("span");
      qty.className = "feed-advisor-product__quantity";
      qty.textContent = `${menu.quantity} x`;
      imgWrap.appendChild(qty);
      row.appendChild(imgWrap);
      item.appendChild(row);
      if (hasVarietyOptions) {
        const dropdown = document.createElement("div");
        dropdown.className =
          "feed-advisor-onepage__typeahead feed-advisor-product__variety";
        const trigger = document.createElement("button");
        trigger.type = "button";
        trigger.className = "feed-advisor-product__variety-trigger";
        trigger.textContent = formatProductNameWithUnit(
          menu.name,
          packageUnitGrams,
        );
        trigger.setAttribute("aria-haspopup", "listbox");
        trigger.setAttribute("aria-expanded", "false");
        const panel = document.createElement("div");
        panel.className =
          "feed-advisor-onepage__typeahead-panel feed-advisor-product__variety-panel";
        panel.setAttribute("role", "listbox");
        panel.hidden = true;

        const renderPanel = (selectedIds) => {
          panel.innerHTML = "";
          const currentId = String(packageData.productData[index]?.id);
          productOptions.forEach((option) => {
            const optionEl = document.createElement("div");
            optionEl.className = "feed-advisor-onepage__typeahead-option";
            optionEl.textContent = formatProductNameWithUnit(
              option.name,
              packageUnitGrams,
            );
            optionEl.setAttribute("role", "option");
            if (String(option.id) === currentId) {
              optionEl.classList.add("is-active");
            }
            if (
              selectedIds.includes(String(option.id)) &&
              String(option.id) !== currentId
            ) {
              optionEl.classList.add("is-disabled");
              optionEl.setAttribute("aria-disabled", "true");
            }
            optionEl.addEventListener("click", () => {
              if (optionEl.classList.contains("is-disabled")) return;
              menu.id = option.id;
              menu.name = option.name;
              menu.img = option.img;
              img.src = option.img;
              img.alt = formatProductNameWithUnit(
                option.name,
                packageUnitGrams,
              );
              trigger.textContent = formatProductNameWithUnit(
                option.name,
                packageUnitGrams,
              );
              packageData.productData[index] = { ...menu };
              panel.hidden = true;
              trigger.setAttribute("aria-expanded", "false");
              rebuildFormData();
              rebuildVarietyOptions();
            });
            panel.appendChild(optionEl);
          });
        };

        trigger.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          const wasOpen = !panel.hidden;
          closeAllVarietyPanels();
          panel.hidden = wasOpen;
          trigger.setAttribute("aria-expanded", String(!wasOpen));
          if (!wasOpen) {
            rebuildVarietyOptions();
          }
        });

        dropdown.appendChild(trigger);
        dropdown.appendChild(panel);
        rowMeta.appendChild(dropdown);
        dropdowns.push({ renderPanel });
        row.appendChild(rowMeta);
      }
      list.appendChild(item);
    });

    rebuildVarietyOptions();

    card.appendChild(list);

    const days = document.createElement("p");
    days.innerHTML = `<b>${dogName} hat Futter für ${packageData.lastInDays} Tage.</b>`;
    card.appendChild(days);

    const grams = document.createElement("p");
    grams.innerHTML = `<b>Dies entspricht ${packageData.caloriesPerDay} g pro Tag.</b>`;
    card.appendChild(grams);

    const button = document.createElement("span");
    button.className =
      "add-to-cart sf__btn flex-grow shrink not-change relative sf__btn-secondary";
    button.textContent = "in den Warenkorb";
    button.onclick = function (e) {
      e.preventDefault();
      const formData = {
        items: packageData.formData,
      };
      console.log("Adding to cart:", formData);
      console.log("Fetch URL:", window.Shopify.routes.root + "cart/add.js");
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          console.log("Response status:", response.status);
          return response.json();
        })
        .then(function (data) {
          console.log("Response data:", data);
          Shopify.onItemAdded();
        })
        .catch(function (error) {
          console.error("Fetch error:", error);
          alert("Error:", error);
        });
    };
    card.appendChild(button);
    return card;
  };

  let lastSubmission = null;

  const renderAdvisorResults = (submission, { scrollToResults = false } = {}) => {
    const collectionData = getSelectedMenuCollectionData();
    const packageUnitGrams = getPackageUnitGrams(collectionData);
    const avgCaloriesPerGram = getAverageCaloriesPerGram(
      collectionData.resolvedProductsList,
      collectionData.availableVariantIds,
      packageUnitGrams,
    );
    const freshGrams = avgCaloriesPerGram
      ? Math.round(submission.calories / avgCaloriesPerGram)
      : null;
    const recommendedSize = getRecommendedSize(submission.weight);
    const recommendedBoxTitle =
      collectionData.packageBoxes?.[recommendedSize]?.title ||
      `Paket ${recommendedSize}`;
    const supplements =
      submission.complaints.includes("none") || submission.complaints.length === 0
        ? []
        : getSupplementSelection(submission.complaints, submission.breed);
    const filteredProducts = filterProductsByAllergies(
      submission.allergyKeys,
      collectionData.resolvedProductsList,
      collectionData.availableVariantIds,
    );
    if (!Object.keys(filteredProducts).length) {
      setGroupError(
        allergiesWrap,
        "Keine passenden Menüs für diese Allergien in der gewählten Kategorie gefunden.",
        "allergies",
      );
      return;
    }
    const packageSWeight = getPackageTotalGrams(
      collectionData.packageBoxes?.S,
      12,
      packageUnitGrams,
    );
    const packageSCount = getPackageCount(collectionData.packageBoxes?.S, 12);
    const packageMWeight = getPackageTotalGrams(
      collectionData.packageBoxes?.M,
      24,
      packageUnitGrams,
    );
    const packageMCount = getPackageCount(collectionData.packageBoxes?.M, 24);
    const packageLWeight = getPackageTotalGrams(
      collectionData.packageBoxes?.L,
      36,
      packageUnitGrams,
    );
    const packageLCount = getPackageCount(collectionData.packageBoxes?.L, 36);
    const packageS = createTwoProductPackage(
      packageSWeight,
      filteredProducts,
      submission.calories,
      packageUnitGrams,
      packageSCount,
    );
    const packageM = createTwoProductPackage(
      packageMWeight,
      filteredProducts,
      submission.calories,
      packageUnitGrams,
      packageMCount,
    );
    const packageL = createTwoProductPackage(
      packageLWeight,
      filteredProducts,
      submission.calories,
      packageUnitGrams,
      packageLCount,
    );
    const urlMap = getAvailableProductsMap(collectionData.frischeMenus);

    if (menuSourceWrap) {
      menuSourceWrap.hidden = menuCollectionKeys.length < 2;
    }
    dogNameEl.textContent = submission.name;
    dogSummaryEl.textContent = `Gewicht: ${submission.weight} kg · Rasse: ${submission.breed} · Empfehlung: ${recommendedBoxTitle}`;
    if (dogCaloriesEl) {
      dogCaloriesEl.textContent = freshGrams
        ? `Empfehlung: ${submission.calories} kcal/Tag · ca. ${freshGrams} g Frische Menü`
        : `Empfehlung: ${submission.calories} kcal/Tag`;
    }

    packagesEl.innerHTML = "";
    packagesEl.classList.add("feed-advisor-products-wrapper");
    packagesEl.appendChild(
      renderPackage(
        "S",
        packageS,
        supplements,
        recommendedSize,
        urlMap,
        submission.name,
        filteredProducts,
        collectionData.packageBoxes,
        packageUnitGrams,
      ),
    );
    packagesEl.appendChild(
      renderPackage(
        "M",
        packageM,
        supplements,
        recommendedSize,
        urlMap,
        submission.name,
        filteredProducts,
        collectionData.packageBoxes,
        packageUnitGrams,
      ),
    );
    packagesEl.appendChild(
      renderPackage(
        "L",
        packageL,
        supplements,
        recommendedSize,
        urlMap,
        submission.name,
        filteredProducts,
        collectionData.packageBoxes,
        packageUnitGrams,
      ),
    );

    renderRecommendedProducts(submission.complaints);
    renderPuppyProduct(submission);
    renderExtraProducts();
    results.hidden = false;
    if (scrollToResults) {
      results.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  menuSourceInputs.forEach((input) => {
    input.checked = input.value === selectedMenuCollectionKey;
    input.addEventListener("change", () => {
      if (!input.checked) return;
      selectedMenuCollectionKey = input.value;
      if (lastSubmission) {
        renderAdvisorResults(lastSubmission);
      }
    });
  });

  form.addEventListener("submit", (event) => {
    event.preventDefault();
    if (!validateForm() || !validateAllergies()) {
      return;
    }

    const formData = new FormData(form);
    const complaints = formData.getAll("complaints").filter(Boolean);
    const allergyKeys = formData
      .getAll("allergies")
      .filter((value) => value !== "no_allergy");
    const weight = Number(formData.get("weight") || 0);
    const breed = String(formData.get("breed") || "");
    const ageFactor = Number(formData.get("age") || 0);
    const weightFactor = Number(formData.get("body") || 0);
    const activeFactor = Number(formData.get("activity") || 0);
    const snacksFactor = Number(formData.get("snacks") || 0);
    const name = String(formData.get("name") || "deinem Hund");
    const calories = Math.round(
      Math.pow(weight, 0.75) *
        weightFactor *
        activeFactor *
        ageFactor *
        snacksFactor,
    );

    lastSubmission = {
      complaints,
      allergyKeys,
      weight,
      breed,
      name,
      calories,
      isPuppy: ageFactor === 2,
    };
    renderAdvisorResults(lastSubmission, { scrollToResults: true });
  });
})();
